export default function BigPhone(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_726_19681)">
                <path
                    d="M21.9811 36.8174C22.7913 36.8174 23.4481 36.1606 23.4481 35.3504C23.4481 34.5402 22.7913 33.8834 21.9811 33.8834C21.171 33.8834 20.5142 34.5402 20.5142 35.3504C20.5142 36.1606 21.171 36.8174 21.9811 36.8174Z"
                    fill="#010101"
                    stroke="#010101"
                    strokeWidth="0.775616"
                />
                <path d="M19.7095 7.505H24.2527" stroke="#010101" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M28.8841 3.85071H15.0782C12.9363 3.85071 11.2001 5.58698 11.2001 7.72879V36.2715C11.2001 38.4133 12.9363 40.1495 15.0782 40.1495H28.8841C31.0259 40.1495 32.7622 38.4133 32.7622 36.2715V7.72879C32.7622 5.58698 31.0259 3.85071 28.8841 3.85071Z"
                    stroke="#010101"
                    strokeWidth="2"
                />
            </g>
            <defs>
                <clipPath id="clip0_726_19681">
                    <rect width="44" height="44" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
